import graphql__fe7fd66a00798c37057b from "./__generated__/ShallowAnswer_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import AnswerString from "./AnswerString";
import AnswerText from "./AnswerText";
import AnswerRichText from "./AnswerRichText";
import AnswerFile from "./AnswerFile";
import AnswerCheckBoxes from "./AnswerCheckBoxes";
import AnswerBudgetDispatcher from "./AnswerBudgetDispatcher";
import AnswerThemes from "./AnswerThemes";
import AnswerEvents from "./AnswerEvents";
import AnswerSortableList from "./AnswerSortableList";
import AnswerMatrix from "./AnswerMatrix";
import AnswerEmailWithConsents from "./AnswerEmailWithConsents";
import AnswerOralInterview from "../OralInterview/AnswerOralInterview";
import AnswerPresentationTitle from "./AnswerPresentationTitle";
import AnswerPresentationTextZone from "./AnswerPresentationTextZone";
import AnswerPresentationSeparator from "./AnswerPresentationSeparator";

export const SHALLOW_ANSWER_TYPES = {
  AnswerText,
  AnswerFile,
  AnswerEvents,
  AnswerString,
  AnswerThemes,
  AnswerRichText,
  AnswerCheckBoxes,
  AnswerBudgetDispatcher,
  AnswerEmailWithConsents,
  AnswerOralInterview,
  AnswerSortableList,
  AnswerMatrix,
  AnswerPresentationTitle,
  AnswerPresentationTextZone,
  AnswerPresentationSeparator
};

// This module allows answers that contain other answers (ex: address) to be
// requested with Relay, since Relay doesn't allow recursive fragment inclusion.
//
// So top-level fields container can render the Answer component, while fields
// that want to render sub answers need to render the ShallowAnswer component
// to avoid recursive fragment inclusion.
//
const ShallowAnswer = props => {
  const answer = useFragment(ShallowAnswer_answer, props.answer);
  const AnswerType = SHALLOW_ANSWER_TYPES[answer.__typename];
  const { parent, isCorrection, correctionTextOnlyOnWrongAnswers, resourceId } = props;

  return (
    <AnswerType
      {...{
        answer,
        isCorrection,
        correctionTextOnlyOnWrongAnswers,
        parent,
        resourceId
      }}
    />
  );
};

const ShallowAnswer_answer = graphql__fe7fd66a00798c37057b;

export default ShallowAnswer;
